import PmsToggle from "./pms-toggle";
import { useDispatch, useSelector } from "react-redux";
import { summaryActions } from "../slice";
import {
  selectBreakdown,
  selectDateComparison,
  selectIsDetailed,
  selectPaceHorizon,
  selectPaceVariable,
  selectPmsSync,
  selectSummaryAlignmentToggle,
  selectSummaryBookingDate,
  selectSummaryForecastFilter,
  selectSummaryOtb,
  selectSymmetricComparisonToggle,
} from "../selectors";
import styles from "../../dashboard.module.scss";
import { Grid } from "@mui/material";
import BookingWindow from "./booking-window";
import { RESET_BOOKING_DATE } from "../../../common/constants/date";
import BreakdownWindow from "./breakdown-window";
import { BREAKDOWN_LIST } from "../../../common/constants/breakdown";
import VsComparisonWindow from "./compare-time";
import { ActionButton, CustomStack } from "../../../common/components";
import { TIME_COMPARISON } from "../../../common/constants/time-comparison";
import { PACE_VARIABLE_LIST } from "../../../common/constants/pace-variable";
import { PACE_LIST } from "../../../common/constants/pace-list";
//
const FilterPanel = () => {
  const dispatch = useDispatch();
  const pmsSyncToggle = useSelector(selectPmsSync);
  const bookingDate = useSelector(selectSummaryBookingDate);
  const customBooking = useSelector(selectSummaryOtb);
  const isDetailed = useSelector(selectIsDetailed);
  const chartBreakdown = useSelector(selectBreakdown);
  const alignmentToggle = useSelector(selectSummaryAlignmentToggle);
  const symmetricComparisonToggle = useSelector(selectSymmetricComparisonToggle);
  const dateComparison = useSelector(selectDateComparison);

  // To select otb or custom booking window
  const handleOTBChange = (event) => {
    const { value } = event.target;
    dispatch(summaryActions.setSummaryOtb(value !== "false"));
    dispatch(summaryActions.setSummaryBookingDate(RESET_BOOKING_DATE));
  };

  // Reset button function to set filter panel values to default
  const clearSearch = () => {
    dispatch(summaryActions.setSummaryOtb(false));
    dispatch(summaryActions.setSummaryForecastFilter(true));
    dispatch(summaryActions.setBreakdown(BREAKDOWN_LIST[0].id));
    dispatch(summaryActions.setPaceHorizon(PACE_LIST[0].id));
    dispatch(summaryActions.setPaceVariable(PACE_VARIABLE_LIST[0].label));
    dispatch(summaryActions.setSymmetricComparisonToggle(true));
    dispatch(summaryActions.setDateComparison(TIME_COMPARISON[2].value));
    dispatch(summaryActions.setSummaryBookingDate(RESET_BOOKING_DATE));
    dispatch(summaryActions.setPmsSync(false));
    dispatch(summaryActions.setSummaryAlignmentToggle(false));
    dispatch(summaryActions.setIsDetailed(false));
  };
  //
  return (
    <Grid pt={2} minWidth={300}>
     <PmsToggle
        value={pmsSyncToggle}
        onChange={(event) => dispatch(summaryActions.setPmsSync(event.target.checked))}
      />
      
      {/* <br />
           <StayDatePicker />
        <br/> */}
      <BookingWindow
        vOTB={customBooking}
        customBooking={customBooking}
        handleOTBChange={handleOTBChange}
        otbValue={false}
        bookingDate={bookingDate}
        cssClassName={styles.bookingCalendarElement}
        handleChange={(item) =>
          dispatch(
            summaryActions.setSummaryBookingDate({
              startDate: new Date(item.selection.startDate).toISOString(),
              endDate: new Date(item.selection.endDate).toISOString(),
              key: "selection",
            })
          )
        }
      />
      <br />
      <BreakdownWindow
        isDetailed={isDetailed}
        chartBreakdown={chartBreakdown}
        chartBreakdownList={BREAKDOWN_LIST}
        handleIsDetailedChange={(event) => {
          const isChecked = event.target.checked;
           // Find the current breakdown item based on the existing chartBreakdown value
          const currentBreakdownItem = BREAKDOWN_LIST.find(
           (item) => item.detailedValue === chartBreakdown || item.simpleValue === chartBreakdown
          );

          // Update chartBreakdown based on the current selection and the new `isDetailed` state
          const newBreakdownValue = isChecked
            ? currentBreakdownItem?.detailedValue
            : currentBreakdownItem?.simpleValue;

          dispatch(summaryActions.setIsDetailed(isChecked));
          dispatch(summaryActions.setBreakdown(newBreakdownValue));
        }}
        handleBreakdownChange={(event) => {
          const selectedOption = BREAKDOWN_LIST.find(
            (item) => item.detailedValue === event.target.value || item.simpleValue === event.target.value
          );
          const breakdownValue = isDetailed
            ? selectedOption.detailedValue
            : selectedOption.simpleValue;

          dispatch(summaryActions.setBreakdown(breakdownValue));
        }}
      />
      <br /> 
      <VsComparisonWindow
        customBooking={customBooking}
        alignmentToggle={alignmentToggle ?? false}
        handleToggleChange={(event) =>
          dispatch(summaryActions.setSummaryAlignmentToggle(event.target.checked))
        }
        symmetricComparisonToggle={symmetricComparisonToggle}
        dateComparison={dateComparison}
        handleComparisonChange={(event) => {
          dispatch(summaryActions.setDateComparison(event.target.value));
        }}
        handleSymmetricComparisonChange={(event) => {
          dispatch(summaryActions.setSymmetricComparisonToggle(event.target.checked));
        }}
      />
      <br />
      {/* <BookingPaceWindow
        paceHorizon={paceHorizon}
        paceVariable={paceVariable}
        handlePaceHorizonChange={(event) => {
          dispatch(summaryActions.setPaceHorizon(event.target.value));
        }}
        handlePaceVariableChange={(event) => {
          dispatch(summaryActions.setPaceVariable(event.target.value));
        }}
        handleForecastFilterChange={(event) => {
          dispatch(summaryActions.setSummaryForecastFilter(event.target.checked));
        }}
        summaryForecastFilter={summaryForecastFilter}
      />
      <br /> */}
      <CustomStack>
        <ActionButton onClick={clearSearch} label="RESET" />
      </CustomStack>
    </Grid>
  );
};
//
export default FilterPanel;
